import { css } from '@emotion/react';
import { Cube } from '@phosphor-icons/react';
import type { OnLog } from 'client/state/LogState';
import { Typography } from 'client/components/Typography';
import { ComponentContainerStatus } from './ComponentContainerStatus';
import type { ComponentStatusTree } from './componentsStatusUtils';

interface ComponentContainersStatusProps {
  deploymentID: number | null | undefined;
  deploymentUrl: string;
  items: ComponentStatusTree['containers'];
  componentIdentifier: string;
  onLog?: OnLog;
}

export const ComponentContainersStatus = ({
  deploymentID,
  deploymentUrl,
  items,
  componentIdentifier,
  onLog,
  ...other
}: ComponentContainersStatusProps) => {
  if (!deploymentID) return null;
  if (!items.length) return null;

  return (
    <section {...other}>
      <Typography variant="body2" css={titleStyle}>
        <Cube weight="bold" /> Containers
      </Typography>
      <ul>
        {items.map((item) => (
          <ComponentContainerStatus
            key={item.name}
            componentIdentifier={componentIdentifier}
            deploymentID={deploymentID}
            deploymentUrl={deploymentUrl}
            item={item}
            onLog={onLog}
          />
        ))}
      </ul>
    </section>
  );
};

const titleStyle = css`
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: bold !important;
  margin-bottom: 4px;
`;
